const worldStates = {
  // some of these are provinces but calling all states for consistency
  ca: [
    "ab",
    "bc",
    "mb",
    "nb",
    "nl",
    "nt",
    "ns",
    "nu",
    "on",
    "pe",
    "qc",
    "sk",
    "yt",
  ],
  us: [
    "al",
    "ak",
    "az",
    "ar",
    "ca",
    "co",
    "ct",
    "de",
    "fl",
    "ga",
    "hi",
    "id",
    "il",
    "in",
    "ia",
    "ks",
    "ky",
    "la",
    "me",
    "md",
    "ma",
    "mi",
    "mn",
    "ms",
    "mo",
    "mt",
    "ne",
    "nv",
    "nh",
    "nj",
    "nm",
    "ny",
    "nc",
    "nd",
    "oh",
    "ok",
    "or",
    "pa",
    "ri",
    "sc",
    "sd",
    "tn",
    "tx",
    "ut",
    "vt",
    "va",
    "wa",
    "wv",
    "wi",
    "wy",
  ],
};

export default worldStates;
